import React from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import Addresses from './addresses';
import PhoneNumbers from './phone_numbers';

export default class ContactInfoForm extends React.Component {
  static propTypes = {
    addresses: PropTypes.array.isRequired,
    phoneNumberLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
    phoneNumbers: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
  }

  get addresses() {
    return this.props.addresses.filter(address => !address._destroy);
  }

  get phoneNumbers() {
    return this.props.phoneNumbers.filter(phoneNumber => !phoneNumber._destroy);
  }

  addAddress = () => {
    this.props.onChange({
      addresses: [
        ...this.props.addresses,
        {
          index: this.props.addresses.length,
          primary: true,
        },
      ]
    });
  }

  addPhoneNumber = () => {
    this.props.onChange({
      phoneNumbers: [
        ...this.props.phoneNumbers,
        {
          index: this.props.phoneNumbers.length,
          label: this.props.phoneNumberLabels[0],
          primary: true
        },
      ]
    });
  }

  handlePhoneNumbersChange = (phoneNumbers) => {
    this.props.onChange({ phoneNumbers });
  }

  render() {
    let phoneNumbersElement;
    if (this.phoneNumbers.length === 0) {
      phoneNumbersElement = (
        <AddControl className="me-4" onClick={this.addPhoneNumber}>
          Add phone/fax
        </AddControl>
      );
    } else {
      phoneNumbersElement = (
        <PhoneNumbers
          labels={this.props.phoneNumberLabels}
          phoneNumbers={this.props.phoneNumbers}
          onChange={this.handlePhoneNumbersChange}
        />
      );
    }

    let addressesElement;
    if (this.addresses.length === 0) {
      addressesElement = (
        <AddControl onClick={this.addAddress}>
          Add address
        </AddControl>
      );
    } else {
      addressesElement = (
        <Addresses
          addresses={this.props.addresses}
          labels={this.props.phoneNumberLabels}
          phoneNumbers={this.props.phoneNumbers}
          onChange={addresses => this.props.onChange({ addresses })}
        />
      );
    }

    return <>
      {phoneNumbersElement}
      {addressesElement}
    </>;
  }
}
